module.exports = __webpack_public_path__ + "img/create-desc.8f2f84bc.png";